// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".molecule-image-thumb-slider{overflow:hidden;overflow-x:auto;padding-bottom:.125rem;position:relative;white-space:nowrap}@media only screen and (max-width:767px){.molecule-image-thumb-slider{margin:0;padding-bottom:3px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
